export default function Projects() {
  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Featured Construction Projects
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our portfolio of successful construction layout design and formwork projects 
            completed across Vancouver, Burnaby, Surrey, and Victoria. Each project showcases 
            our commitment to excellence and attention to detail.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/55454556e79511a8f6c3b7c4134a4d62.jpg"
              alt="The Collingwood - Vancouver"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">The Collingwood</h3>
              <p className="text-gray-600 mb-3">
                Premium residential development requiring sophisticated formwork design and construction layout for complex architectural concrete features.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Vancouver</span>
                <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm">Premium</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2024</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20completed%20residential%20building%20on%20Birch%20Street%20Vancouver%2C%20contemporary%20four-story%20apartment%20architecture%20with%20clean%20lines%2C%20white%20and%20wood%20exterior%20facade%2C%20large%20windows%2C%20finished%20residential%20construction%2C%20professional%20architectural%20photography%2C%20no%20construction%20equipment%20visible&width=400&height=300&seq=sparrow-house-completed&orientation=landscape"
              alt="Sparrow House - Vancouver"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sparrow House</h3>
              <p className="text-gray-600 mb-3">
                Boutique residential project on Birch Street featuring detailed construction layout and custom formwork for unique architectural elements.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Vancouver</span>
                <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">Boutique</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2024</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Revolve%20residential%20building%20Vancouver%20BC%2C%20modern%20high-rise%20apartment%20construction%2C%20urban%20Vancouver%20architecture%2C%20contemporary%20residential%20development%2C%20professional%20construction%20photography%2C%20city%20skyline%20background&width=400&height=300&seq=revolve&orientation=landscape"
              alt="Revolve - Vancouver"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Revolve</h3>
              <p className="text-gray-600 mb-3">
                High-density residential tower requiring advanced formwork engineering and precise construction layout for efficient vertical construction.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Vancouver</span>
                <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm">High-Density</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2023</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Eastern%20residential%20development%20North%20Vancouver%20BC%2C%20modern%20apartment%20construction%2C%20mountain%20backdrop%20Vancouver%20North%20Shore%2C%20contemporary%20residential%20architecture%2C%20professional%20construction%20photography%2C%20clean%20modern%20design&width=400&height=300&seq=eastern&orientation=landscape"
              alt="Eastern - North Vancouver"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Eastern</h3>
              <p className="text-gray-600 mb-3">
                North Shore residential project featuring challenging terrain construction layout and custom formwork solutions for hillside development.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">North Vancouver</span>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">Hillside</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2023</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Fraser%20Commons%20residential%20development%20Vancouver%20BC%2C%20modern%20apartment%20building%20construction%2C%20urban%20residential%20architecture%2C%20contemporary%20design%20with%20concrete%20and%20glass%2C%20professional%20construction%20photography%2C%20Vancouver%20cityscape&width=400&height=300&seq=fraser-commons&orientation=landscape"
              alt="Fraser Commons - Vancouver"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Fraser Commons</h3>
              <p className="text-gray-600 mb-3">
                Urban residential development requiring precise construction layout and specialized formwork design for mixed-use building components.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Vancouver</span>
                <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm">Mixed-Use</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2022</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Sawmill%20residential%20development%20Burnaby%20BC%2C%20modern%20townhouse%20construction%20project%2C%20contemporary%20residential%20architecture%2C%20construction%20site%20with%20formwork%20systems%2C%20professional%20construction%20photography%2C%20clean%20modern%20design&width=400&height=300&seq=sawmill&orientation=landscape"
              alt="Sawmill - Burnaby"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sawmill</h3>
              <p className="text-gray-600 mb-3">
                Multi-phase residential project with complex layout requirements and innovative formwork solutions for efficient construction delivery.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Burnaby</span>
                <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">Multi-Phase</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2022</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Vittorio%20luxury%20residential%20development%20Burnaby%20BC%2C%20modern%20apartment%20building%20construction%2C%20contemporary%20urban%20architecture%2C%20high-quality%20residential%20project%2C%20professional%20construction%20photography%2C%20clean%20architectural%20design&width=400&height=300&seq=vittorio&orientation=landscape"
              alt="Vittorio - Burnaby"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Vittorio</h3>
              <p className="text-gray-600 mb-3">
                Premium residential development featuring advanced construction techniques and detailed formwork planning for architectural concrete features.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Burnaby</span>
                <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">Luxury</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2021</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Fulton%20House%20luxury%20residential%20building%20Burnaby%20BC%2C%20modern%20high-rise%20apartment%20construction%2C%20contemporary%20architecture%20with%20glass%20and%20concrete%2C%20urban%20residential%20development%2C%20professional%20construction%20photography%2C%20clean%20modern%20design&width=400&height=300&seq=fulton-house&orientation=landscape"
              alt="Fulton House - Burnaby"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Fulton House</h3>
              <p className="text-gray-600 mb-3">
                High-rise residential project requiring specialized formwork design and precise construction layout for complex architectural elements.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Burnaby</span>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">High-Rise</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2021</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20residential%20townhouse%20development%20Willoughby%20Walk%20Langley%20BC%20with%20contemporary%20architecture%2C%20multi-story%20residential%20buildings%2C%20clean%20modern%20design%2C%20landscaped%20community%20setting%2C%20professional%20construction%20photography%2C%20high%20quality%20residential%20development&width=400&height=300&seq=willoughby-walk&orientation=landscape"
              alt="Willoughby Walk - Langley"
              className="w-full h-48 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Willoughby Walk</h3>
              <p className="text-gray-600 mb-3">
                Modern residential development featuring precise layout design and formwork solutions for contemporary townhouse construction.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Langley</span>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">Residential</span>
                <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">2020</span>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">50+ Successful Projects Completed</h3>
            <p className="text-gray-600 mb-6">
              These featured projects represent just a selection of our completed work across Vancouver, Burnaby, Surrey, 
              Langley, and North Vancouver. Each project demonstrates our expertise in construction layout design, 
              formwork engineering, and project delivery excellence.
            </p>
            <div className="bg-blue-50 rounded-lg p-6">
              <h4 className="font-semibold text-blue-900 mb-3">Our Project Expertise Includes:</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left text-blue-800 max-w-2xl mx-auto">
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    High-rise residential towers
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Townhouse developments
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Mixed-use buildings
                  </li>
                </ul>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Custom formwork design
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Complex layout solutions
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Architectural concrete
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
